import { useEffect, useCallback } from 'react';

import { Hub } from '../auth';

export const AMPLIFY_AUTH_EVENT = 'amplifyauth';

export function useSetNullOnSignOut(setter) {
  const handleAuth = useCallback(message => {
    if (message.payload.event === 'signOut') {
      setter(null);
    }
  }, []);
  useEffect(() => {
    return Hub.listen('auth', handleAuth);
  }, [handleAuth]);
}

export function useSignInEvent(setUser) {
  const handleAuth = useCallback(message => {
    const { payload: { event } } = message;

    switch (event) {
      case 'signIn':
        setUser(message.payload.data);
        break;
    }
  }, []);
  useEffect(() => {
    return Hub.listen('auth', handleAuth);
  }, [handleAuth]);
}

export function useAuthEventDispatch() {
  const handleAuth = useCallback(message => {
    window.dispatchEvent(new CustomEvent(AMPLIFY_AUTH_EVENT, {
      detail: message,
    }));
  }, []);
  useEffect(() => {
    return Hub.listen('auth', handleAuth);
  }, [handleAuth]);
}